import PropTypes from 'prop-types';
import BorderBox from '../components/BorderBox';
import { PageTitle } from './typography/Heading';

const GeneralError = (props) => {
    if (typeof props.error === 'object') {
        return null;
    }
    return (
        <div className="max-on-big content padding-page-normal center">
            <BorderBox>
                <PageTitle>Ooops!</PageTitle>
                <p>{props.error}</p>
                {props.children}
            </BorderBox>
        </div>
    );
};

GeneralError.propTypes = {
    error: PropTypes.string.isRequired,
    children: PropTypes.element,
};

export default GeneralError;
